"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

var React = __importStar(require("react"));

var getProp_1 = __importDefault(require("sportnet-utilities/lib/getProp"));

var styled_components_1 = __importDefault(require("../Themes/styled-components"));

var FormGroupContext_1 = __importDefault(require("../FormGroup/FormGroupContext"));

var Select = styled_components_1.default('select')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border-radius: ", ";\n  background-color: white;\n  border: solid ", "\n    ", ";\n  font-size: ", ";\n  padding: 0 ", ";\n  height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  padding-right: ", ";\n  &:focus {\n    border-color: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n  }\n"], ["\n  width: 100%;\n  border-radius: ", ";\n  background-color: white;\n  border: solid ", "\n    ", ";\n  font-size: ", ";\n  padding: 0 ", ";\n  height: ", ";\n  color: ", ";\n  font-family: ", ";\n  outline: 0;\n  padding-right: ", ";\n  &:focus {\n    border-color: ", ";\n  }\n  &:disabled {\n    -webkit-text-fill-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.baseBorderRadius;
}, polished_1.rem(1), function (_a) {
  var theme = _a.theme,
      error = _a.error;
  return error ? theme.color.danger : theme.separatorColor;
}, polished_1.rem(14), polished_1.rem(10), polished_1.rem(38), function (_a) {
  var theme = _a.theme;
  return theme.textColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, polished_1.rem(21), function (_a) {
  var theme = _a.theme;
  return theme.color.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.inactiveColor;
});
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));

var CompSelect =
/** @class */
function (_super) {
  __extends(CompSelect, _super);

  function CompSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.iterateOptions = function (options, value) {
      var exists = false;

      if (Array.isArray(options)) {
        exists = options.some(function (option) {
          return _this.iterateOptions(option, value) === true;
        });
      } else if (getProp_1.default(options, ['props', 'value']) === value) {
        exists = true;
      }

      return exists;
    };

    _this.renderOptions = function () {
      var _a = _this.props,
          children = _a.children,
          value = _a.value,
          createUnknownOption = _a.createUnknownOption;

      if (!createUnknownOption || !value) {
        return children;
      }

      var option = null;

      var exists = _this.iterateOptions(children, value);

      if (!exists) {
        option = React.createElement("option", {
          value: value
        }, value);
      }

      return [option].concat(children);
    };

    console.warn('Select is DEPRECATED. Use TheSelect instead.');
    return _this;
  }

  CompSelect.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        restProps = __rest(_a, ["className", "children"]);

    return React.createElement(FormGroupContext_1.default.Consumer, null, function (value) {
      return React.createElement(Wrapper, {
        className: className
      }, React.createElement(Select, __assign({}, restProps, {
        ref: _this.props.inputRef,
        id: _this.props.id || value.id
      }), _this.renderOptions()));
    });
  };

  CompSelect.defaultProps = {
    className: '',
    id: null,
    inputRef: function inputRef() {},
    createUnknownOption: true
  };
  return CompSelect;
}(React.PureComponent);

exports.default = CompSelect;
var templateObject_1, templateObject_2;